"use strict";

exports.__esModule = true;
var CookieUtil = {
    get: function () {
        function get(name) {
            var cookieName = encodeURIComponent(name) + "=",
                cookieStart = document.cookie.indexOf(cookieName),
                cookieValue = null;
            if (cookieStart > -1) {
                var cookieEnd = document.cookie.indexOf(";", cookieStart);
                if (cookieEnd == -1) {
                    cookieEnd = document.cookie.length;
                }
                cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
                return cookieValue;
            }
        }

        return get;
    }(),
    set: function () {
        function set(name, value, expires, path, domain, secure) {
            var cookieText = encodeURIComponent(name) + "=" + encodeURIComponent(value);
            if (expires instanceof Date) {
                cookieText += "; expires=" + expires.toGMTString();
            }
            if (path) {
                cookieText += "; path=" + path;
            }
            if (domain) {
                cookieText += "; domain=" + domain;
            }
            if (secure) {
                cookieText += "; secure";
            }
            document.cookie = cookieText;
        }

        return set;
    }(),
    unset: function () {
        function unset(name, path, domain, secure) {
            this.set(name, "", new Date(0), path, domain, secure);
        }

        return unset;
    }()
};

exports.default = CookieUtil;


//////////////////
// WEBPACK FOOTER
// ./src/util/CookieUtil.js
// module id = 503
// module chunks = 0